define('home/views/SettingsBlockingUserListView',[
    'backbone-marionette',

    'home/templates/settingsBlockingEmpty',
    'home/templates/settingsBlockingUser',
], function (
    Marionette,

    settingsBlockingEmptyTemplate,
    settingsBlockingUserTemplate
) {
    'use strict';

    var SettingsBlockingUserListView = Marionette.CollectionView.extend({
        itemView: Marionette.ItemView.extend({
            template: settingsBlockingUserTemplate,
            className: 'block-list',
        }),
        emptyView: Marionette.ItemView.extend({
            template: settingsBlockingEmptyTemplate,
            className: 'block-list',
        }),
    });

    return SettingsBlockingUserListView;
});

